<template lang="html">

<div class="upload-img">
      <div v-if="upstate=='uploading'">
        <el-button disabled size="small" type="primary">
             <span>上传中...</span>
             <i class="icon el-icon-loading"></i>
        </el-button>
      </div>
      <el-upload
        v-else
        class="upload-demo"
        ref="upload"
        accept="image/*,.pdf"
        :on-success="handleSuccess"
        :before-upload="beforeUpload"
        :on-remove="handleRemove"
        :on-progress="handleProgress"
        :show-file-list="false"
        list-type="picture">
        <el-button size="small" type="primary">
             <span v-if="!nowKey">点击上传</span>
             <span v-else>更新</span>
        </el-button>
        <div slot="tip" class="el-upload__tip">只能上传 jpg/jpeg/png/pdf 文件，且不超过 2M</div>
      </el-upload>
</div>

</template>

<script>
import { getToken } from '@/utils/auth';
import { getFileToken,getViewKey,detFile } from '@/api/account';
export default {
    props:['listType','limit','image'],
    computed:{
         viewUrl:function(){
             return this.viewDat.imagePreUrl + '/id/' + this.nowKey + '/token/' + this.viewDat.token;
         }
    },
    watch:{
         image:function(e){
            if(e){
                 this.upstate = 'uploaded';
                 this.nowKey = e;
            }
         }
    },
    data(){
        return{
            fileList: [],
            upstate:'wait',
            upgress:0,
            postDat:'',

            viewDat:'',
            nowKey:''
        }
    },
    methods:{
        beforeUpload:function(file){
            var isImage = file.type.split('\/')[0] === 'image';

            var isLt100M = file.size / 1024 / 1024 <= 2;
            if (!isLt100M) {
                this.$message.error('文件大小不能超过 2 MB!');
            }

            if(!isImage){
                this.$message.error('只能上传格式为 jpg/jpeg/png/pdf 的文件');
            }

            if(isLt100M && isImage){
               this.upstate = 'uploading';
               return true;
            }
        },

        handleProgress:function(e,file,list){
            this.upgress = e.percent;
        },

        handleSuccess:function(res,flie,fileList){
            this.upstate = 'uploaded',
            this.upgress = 0;

            if(this.nowKey){
                 detFile({id:this.nowKey,fileType:1});
            }
            this.nowKey = this.postDat.key;
            this.$emit('imgChange',this.nowKey);
        }
    },
    mounted:function(){
             let vm = this;
             var userInfo = this.$store.getters.userInfo;

             this.$refs.upload.$refs['upload-inner'].uploadFiles = function(files){
                 let svm = vm.$refs.upload.$refs['upload-inner'];
                 if (svm.limit && svm.fileList.length + files.length > svm.limit) {
                   svm.onExceed && svm.onExceed(files, svm.fileList);
                   return;
                 }
                 let postFiles = Array.prototype.slice.call(files);
                 if (!svm.multiple) { postFiles = postFiles.slice(0, 1); }
                 if (postFiles.length === 0) { return; }

                 getFileToken({userId:userInfo.userId,fileType:1}).then(res => {
                     vm.postDat = res;
                     postFiles.forEach(rawFile => {
                       svm.onStart(rawFile);
                       rawFile.postUrl = vm.postDat.fileUploadUrl;
                       if (svm.autoUpload) svm.upload(rawFile);
                     });
                 }).catch(err => {})

             };

             this.$refs.upload.$refs['upload-inner'].post = function(rawFile){
                  const { uid } = rawFile;
                  let svm = vm.$refs.upload.$refs['upload-inner'];
                  let s = {
                      token:getToken(),
                      key:vm.postDat.key,
                      fileSize:rawFile.size
                  };
                      const options = {
                        headers: svm.headers,
                        withCredentials: this.withCredentials,
                        file: rawFile,
                        data: s,
                        filename: svm.name,
                        action: rawFile.postUrl,
                        onProgress: e => {
                          svm.onProgress(e, rawFile);
                        },
                        onSuccess: res => {
                          svm.onSuccess(res, rawFile);
                          delete this.reqs[uid];
                        },
                        onError: err => {
                          svm.onError(err, rawFile);
                          delete this.reqs[uid];
                        }
                      };
                      const req = svm.httpRequest(options);
                      svm.reqs[uid] = req;
                      if (req && req.then) {
                        req.then(options.onSuccess, options.onError);
                      }
             };
    },
    created:function(){
         getViewKey().then(res => {
             this.viewDat = {
                 imagePreUrl:res.imagePreUrl,
                 token:res.token
             }
         })
    }
}
</script>

<style lang="css" scoped>

.upload-img{
    width: 420px;
    padding-top: 2px;
}

.el-upload__tip{
    display: inline-block;
    margin-left: 12px;
}

.imgCard{
    width: 120px;
    height: 120px;
    border-radius: 6px;
    border:1px solid #F1F1F1;
    margin-top: 12px;
}

.imgCard img{
   width: 120px;
   height: 120px;
}

.imgCard .pgress{
   margin: 15px;
}

</style>



// WEBPACK FOOTER //
// firmUpload.vue?0d292cc2